import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import CounterComponent from '../../../uiElements/storeComponents/counterComponent/CounterComponent';
import { isValidObject, isValidString } from '../../../../catalog/Validity';
import { context } from '../../../../globalState/GlobalState';
import { cdnImage, ImageWidth } from '../../../../catalog/ImageCdn';

// One cart line (option A, shared by ticket and product items): thumbnail, type tag, title, detail lines, quantity
// stepper, a quiet "Remove" link and the line total. Styles live in css/CartDrawer1.
const CartRow1 = (props) => {
    const { image, tag, tagStyle, title, details, quantity, onIncrement, onDecrement, onRemove, lineTotal } = props;
    const { globalState } = useContext(context);
    // Items without their own image show the team logo instead of an empty square.
    const logo = isValidObject(globalState.logo) && isValidString(globalState.logo.logo2) ? globalState.logo.logo2 : '';

    return (
        <div className="cart1-row">
            <span className={`cart1-thumb${isValidString(image) ? '' : ' cart1-thumb-logo'}`}>
                {isValidString(image) || isValidString(logo) ? <img src={cdnImage(isValidString(image) ? image : logo, ImageWidth.THUMB)} alt="" loading="lazy" /> : null}
            </span>
            <div className="cart1-info">
                <span className="cart1-tag" style={tagStyle}>{tag}</span>
                <span className="cart1-title">{title}</span>
                {details.filter((line) => { return isValidString(line); }).map((line) => {
                    return <span key={line} className="cart1-detail">{line}</span>;
                })}
                <div className="cart1-row-bottom">
                    <CounterComponent count={quantity} increment={onIncrement} decrement={onDecrement} />
                    <button type="button" className="cart1-remove" onClick={onRemove}>Remove</button>
                    <span className="cart1-line-total">{lineTotal}</span>
                </div>
            </div>
        </div>
    );
};

CartRow1.propTypes = {
    image: PropTypes.string,
    tag: PropTypes.string.isRequired,
    tagStyle: PropTypes.object,
    title: PropTypes.string.isRequired,
    details: PropTypes.array,
    quantity: PropTypes.number.isRequired,
    onIncrement: PropTypes.func.isRequired,
    onDecrement: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    lineTotal: PropTypes.string.isRequired,
};

CartRow1.defaultProps = {
    image: '',
    tagStyle: undefined,
    details: [],
};

export default memo(CartRow1);
